module.exports = __webpack_public_path__ + "img/img-3.0b2b5375.svg";